import {
  ASPECT_RATIO,
  ASPECT_RATIO_POW,
  gridPhotos
} from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '1 - 5x7, 1 - 3x5, 2 - 2x3',
  imageCount: 4,
  displayGroup: 'DG_5X7_WALLET',
  calc: (height) => {
    const p1Height = (height * ASPECT_RATIO_POW) / (ASPECT_RATIO_POW + 2);
    const p1Width = p1Height / ASPECT_RATIO;
    const p4Width = (height * 2) / (ASPECT_RATIO_POW + 2);
    const p4Height = p4Width * ASPECT_RATIO;

    return {
      gridTemplate: `
        'p1 p2 p3' ${p1Height}px
        'p4 p4 p3' ${p4Width}px
        / ${p1Width}px ${p1Width}px ${height / ASPECT_RATIO}px`,
      photos: [
        ...gridPhotos(1, 2, p1Width, p1Height),
        {
          gridArea: 'p3',
          width: height / ASPECT_RATIO,
          height
        },
        {
          gridArea: 'p4',
          width: p4Width,
          height: p4Height,
          rotation: -90
        }
      ]
    };
  }
};
